/*global google:false */
/*global PhotoSwipe:false */
/*global PhotoSwipeUI_Default:false */
/*global WebFont:false */
/*global placeholder:false */

(function($) {
	"use strict";

	var page          = {};
	page.home         = ($(document.body).hasClass('home'));
	page.simpleList   = ($(document.body).hasClass('page-template-simple-list'));
	page.simple       = ($(document.body).hasClass('simple'));
	page.roomList     = ($(document.body).hasClass('page-template-rooms'));
	page.room         = ($(document.body).hasClass('single-room'));
	page.photoGallery = ($(document.body).hasClass('photo-gallery'));
	page.contact      = ($(document.body).hasClass('page-template-contact'));

	window.bpLarge   = 1280;
	window.bpIPadMax = 1024;
	window.bpMedium  = 960;
	window.bpIPadMin = 768;
	window.bpSmall   = 640;


	/**
	 * breakpoints
	 */
	window.width = $(window).width();
	window.windowInnerWidth = window.innerWidth || $(window).width();
	window.windowInnerHeight = window.innerHeight || $(window).height();

	if (window.width !== window.windowInnerWidth) {
		window.scrollBar = true;
	} else {
		window.scrollBar = false;
	}

	$(document).ready(function ($) {
		"use strict";

		if ($('#fixed-message').length > 0) {
			var messageHeight = $('#fixed-message').innerHeight() + 1;
			$('#main-header').css({'margin-top':messageHeight});
		}

		/**
		 * Page Inner Slider
		 */
		var gallerySlideshow = $("*[data-gallery-slideshow]");
		if (gallerySlideshow.length > 0) {
			gallerySlideshow.each(function() {
				var el = $(this);

				el.flickity({
					contain: true,
					cellSelector: ".slideshow-cell",
					accessibility: true,
					prevNextButtons: el.find(".slideshow-cell").length > 1,
					pageDots: el.find(".slideshow-cell").length > 1,
					// arrowShape: "M.39 27.93c0 1.7 1.36 2.73 2.72 2.73h41.86l-10.9 11.23c-1.01 1.02-1.01 2.72 0 4.08.69.68 1.37.68 2.05.68.68 0 1.36-.34 2.04-.68l15.65-16c1.03-1.02 1.03-2.72 0-4.08l-15.65-16c-1.02-1.01-2.72-1.01-4.08 0-1.02 1.03-1.02 2.73 0 4.1L44.97 25.2H2.77c-1.02 0-2.38 1.02-2.38 2.72",
					// setGallerySize: false,
					imagesLoaded: true,
					lazyLoad: true,
					wrapAround: true
				});

				if (el.data('photoswipe-options')) {
					el.photoswipeLightbox(el.data('photoswipe-options'));
				}

			});
		}

		var $awards = $('#awards-items');
		if ($awards.length) {
			$('#awards-items').slick({
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							infinite: true,
							dots: true
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true
						}
					}
				]
			});
		}

		// Google Map
		var $map = $('.map');
		if ($map.length > 0) {
			var elMap = $map;

			elMap.googleMap(elMap.data('json'));
		}

		var $body = $('body');
		if (window.innerHeight > window.innerWidth) {
			$body.addClass('portrait');
		} else {
			$body.addClass('landscape');
		}

		menu($body);

		aPreventDefault({
			notPage: page.roomList
		});

		headerChecker();

		tabs();

		scrollToggle();

		scroller({
			item: '.animate-this',
			tilt: 200,
			page: page.simpleList
		});

		// Accommodation Filtering
		if (page.photoGallery || page.roomList) {
			var $filters = $('#nav-tabs');
			if ($filters.length > 0) {
				var $listingWrapper = $('#content-tabs').imagesLoaded( function() {
					$listingWrapper.isotope({
						itemSelector: '.item'
					});
					$filters.on('click', 'a', function() {
						var filterValue = $(this).attr('data-filter');
						$listingWrapper.isotope({
							filter: filterValue
						});
					});
				});
			}
		}

		// Masonry Gallery
		var $gallery = $('#masonry-gallery');
		if ($gallery.length > 0) {
			$gallery.imagesLoaded( function() {
				// init Isotope after all images have loaded
				$gallery.isotope({
					layoutMode: 'packery',
					packery: {
						columnWidth: '.gallery-item-sizer'
					},
					itemSelector: '.gallery-item',
					percentPosition: true
				});
			});

			// filter items on button click
			$('#masonry-gallery-filters li').on('click', 'a', function() {
				$('#masonry-gallery-filters li a').not(this).removeClass('active');
				$(this).addClass('active');


				$gallery.isotope({
					filter: $(this).attr('data-filter')
				});
			});

			// Lightbox
			$gallery.photoswipeLightbox($gallery.data('photoswipe-options'));
		}

		/**
		 * Webhotelier Form
		 */
		var $webhotelierForm = $("#webhotelier-form");
		if ($webhotelierForm.length > 0 ) {
			var elWebhotelierForm = $webhotelierForm;
			elWebhotelierForm.webhotelierForm(elWebhotelierForm.data("json"));
		}

		/**
		 * First Slideshow
		 */
		var $firstSlideshow = $("*[data-first-slideshow]");
		if ($firstSlideshow.length > 0) {
			$firstSlideshow.flickity({
				contain: true,
				autoPlay: true,
				cellSelector: ".slideshow-cell",
				accessibility: true,
				prevNextButtons: true,
				// setGallerySize: false,
				arrowShape: 'M68.29 93.62c.6.6 1.36.9 2.2.9s1.6-.3 2.2-.9a3.11 3.11 0 0 0 0-4.4l-38.7-38.7 38.7-38.7a3.11 3.11 0 0 0-4.4-4.41L27.3 48.31a3.11 3.11 0 0 0 0 4.4l40.98 40.9z',
				imagesLoaded: true,
				lazyLoad: true,
				draggable: ">1",
				wrapAround: true
			});
		}
	});

	function menu($body) {
		"use strict";

		(function($) {

			var $wrapperNavbar = $('#wrapper-navbar'),
				$openBtn = $('#main-nav__button--toggle'),
				$header = $('#main-header');

			$openBtn.on({
				'click': function() {
					$wrapperNavbar.toggleClass('open');
					$(this).toggleClass('open');
					$body.toggleClass('prevent-scroll');
					$body.toggleClass('menu-opened');

					if ($body.hasClass('menu-opened')) {
						if (!$header.hasClass('scrolled')) {
							$header.addClass('fake-scrolled');
						}

					} else {
						if ($header.hasClass('fake-scrolled')) {
							$header.removeClass('fake-scrolled');
						}
					}
				}
			});
		})(jQuery);
	}


	function aPreventDefault(options) {

		var defaults = {
			page: true,
			// Not this page
			notPage: false
		};

		options = $.extend( {}, defaults, options );

		if (options.page & !options.notPage) {

			$("a[href$='#']").on( {
				click: function (e) {
					e.preventDefault();
				}
			});

		}
	}

	function headerChecker(options) {
		var defaults = {
			item: '#main-header',
			page: true,
			tilt: 50
		};

		options = $.extend( {}, defaults, options );


		var $mainHeader = $('#main-header'),
			$mainBody = $('#main-body'),
			scroll;

		$mainBody.on('scroll', function () {
			// scroll = getCurrentScroll();

			scroll = lookOffsetTop('#pseudo-header');

			if (scroll <= -10) {
				$mainHeader.addClass('scrolled');
			} else {
				$mainHeader.removeClass('scrolled');
			}
		});
	}

	function scrollToggle() {
		if (page.roomList) {

			var $tabs = $('#tabs');

			if ($tabs.length) {
				var $navTabs = $('#nav-tabs'),
					headerHeight = $('#main-header').height(),
					navTabsOffsetY = $('#nav-tabs').offset().top,
					tilt = navTabsOffsetY - headerHeight,
					scroll;

				$('#main-body').on({
					'scroll': function () {

						scroll = lookOffsetTop('#main-section');
						// console.log(scroll);
						// console.log(headerHeight);

						if (scroll <= headerHeight) {
							if ($('#nav-tabs').hasClass('fixed')) {
								// do not do anything
							} else {

								// $tabs.css({
								//     paddingTop: (headerHeight < 70) ? headerHeight + 48: 70 + 48
								// });

								$navTabs.addClass('fixed').css({
									top: (headerHeight < 70) ? headerHeight : 70
								});
							}
						} else {
							// $tabs.css({
							//     paddingTop: 0
							// });

							$('#nav-tabs').removeClass('fixed').css({
								top: 0
							});
						}
					}
				});
			}
		}
	}

	function scroller(options) {

		var defaults = {
			item: '.animate-this',
			page: true,
			tilt: 50
		};

		options = $.extend( {}, defaults, options );

		if (options.page) {

			$(options.item).each(function () {
				var $thisItem = $(this);

				// check first if it's in visible area and show it
				if ($thisItem.position().top < (window.windowInnerHeight - options.tilt)) {
					if ($thisItem.hasClass('revealed')) {
						// do not do anything
					} else {
						$thisItem.addClass('revealed');
					}
				}

				// Scroll and reveals
				$('#main-body').scroll(function () {
					var scroll = getCurrentScroll();

					if ($thisItem.position().top < (scroll + window.windowInnerHeight - options.tilt)) {
						if ($thisItem.hasClass('revealed')) {
							// do not do anything
						} else {
							$thisItem.addClass('revealed');
						}
					}
				});
			});
		}
	}

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	function lookOffsetTop(element) {
		if ($(element).length > 0) {
			return $(element).offset().top;
		}
	}

	function tabs() {
		if (page.contact) {
			var $tabs = $('#tabs'); // If multiple tabs exist looking for .tabs class

			if ($tabs.length) {

				var $navTabs = $('#nav-tabs'),
					$contentTabs = $('#content-tabs');

				$navTabs.find('.nav-tab').on('click', function(e) {
					var $this = $(this);
					var href = $this.find('a').attr('href');

					$this.find('a').addClass('active');
					$this.siblings().children('a').removeClass('active');

					e.preventDefault();

					var $matchingItem = $contentTabs.find(href);
					$matchingItem.addClass('active');
					$matchingItem.siblings().removeClass('active');
				});
			}
		}
	}

})(jQuery);

(function($) {

	"use strict";

	/**
	 * Webhotelier Form Functon
	 *
	 * @param options
	 */
	$.fn.webhotelierForm = function(options) {
		var el = $(this);

		var settings = $.extend({
			"split_dates": $(this).data("split_dates"),
			"icon_dates": $(this).data("icon_date"),
		}, options);

		var checkinDateSplit = el.find("#checkin-date-split");

		function getField(id) {
			var el = $("#" + id + "-picker");
			return el.length ? el : null;
		}

		function fillSplitDates(id) {
			var el = getField(id);
			if (el !== null) {
				var date = el.datepicker("getDate");
				el.parent().find(".day").text(date.getDate());
				el.parent().find(".month").text(date.toLocaleString(document.documentElement.lang,{month: "short"}));
				el.parent().find(".year").text(date.getFullYear());
			}
		}

		function pickerSetup(id, date) {
			var el = getField(id);

			if (el !== null) {
				var checkin = (id === "checkin");

				el.datepicker({
					altField: el.get(0).form[id],
					altFormat: "yy-mm-dd",
					dateFormat: "d M yy",
					onSelect: function () {
						if (checkin && getField("checkout") !== null) {
							var constraint = new Date(el.datepicker("getDate"));
							constraint.setDate(constraint.getDate() + 1);
							getField("checkout").datepicker("option", "minDate", constraint);
						}
						if ( settings.split_dates ) {
							fillSplitDates(id);
						}
					},
					numberOfMonths: 2,
					mandatory: true,
					firstDay: 1,
					minDate: checkin ? 0 : 1,
					maxDate: "+2y",
					showOn: settings.icon_date ? "button" : "focus",
					buttonImage: settings.icon_date ? settings.icon_date : "",
					buttonImageOnly: settings.icon_date ? "true" : "false",
					buttonText: "Select date"
				});
				// el.datepicker("setDate", date);

				if ( checkinDateSplit.length > 0 ) {
					fillSplitDates(id);
				}
			}
		}

		pickerSetup("checkin", "+0");
		pickerSetup("checkout", "+1");

		if ( checkinDateSplit.length > 0 ) {
			$("#checkin-date-split, #checkout-date-split").on("click", function() {
				$( this ).parent().find("input").datepicker( "show" );
			});
		} else {
			$("#checkin-picker, #checkout-picker").on("click", function() {
				$( this ).datepicker( "show" );
			});
		}

		$( this ).find("select").selectmenu({
			icons: { button: "ui-icon-caret-2-n-s" }
		});

	};


	// Photoswipe Lightbox
	$.fn.photoswipeLightbox = function(options) {
		var el = $(this);

		var settings = $.extend({
			closeOnScroll: true,
			escKey: true,
			arrowKeys: true,
			loop: true,
			history: true,
			focus: true,
			modal: true,
			showHideOpacity: true,
			closeEl: true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			shareEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,
		}, options);

		el.each( function() {

			var $pic     = $(this),
				getItems = function() {
					var items = [];

					$pic.find('a').each(function() {

						var $href   = $(this).data('src'),
							$w   = $(this).data('width'),
							$h  = $(this).data('height'),
							$msrc  = $(this).find('img').attr('src'),
							$title  = $(this).data('title'),
							$pid  = $(this).data('slug');

						var item = {
							src : $href,
							w   : $w,
							h   : $h,
							msrc   : $msrc,
							title   : $title,
							pid   : $pid
						};

						items.push(item);
					});

					return items;
				};

			var items = getItems();

			var $pswp = $('.pswp')[0];
			$pic.on('click', 'a', function(event) {
				event.preventDefault();

				var $index = $(this).data('index');
				var options = {
					index: $index,
					bgOpacity: 0.7,
					spacing: 0.12,
					allowPanToNext: true,
					pinchToClose: true,
					closeOnScroll: settings.closeOnScroll,
					closeOnVerticalDrag: true,
					escKey: settings.escKey,
					arrowKeys: settings.arrowKeys,
					history: settings.history,
					mouseUsed: false,
					loop: settings.loop,
					focus: settings.focus,
					modal: settings.modal,
					showHideOpacity: settings.showHideOpacity,
					showAnimationDuration: 333,
					hideAnimationDuration: 333,
					closeEl: settings.closeEl,
					captionEl: settings.captionEl,
					fullscreenEl: settings.fullscreenEl,
					zoomEl:  settings.zoomEl,
					shareEl:  settings.shareEl,
					counterEl: settings.counterEl,
					arrowEl: settings.arrowEl,
					preloaderEl:  settings.preloaderEl,
				};

				// Initialize PhotoSwipe
				var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
				lightBox.init();
			});
		});

	};

	// Google Map Function
	$.fn.googleMap = function(options) {
		var el = $(this);

		var settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		var markers = [];
		var bounds = new google.maps.LatLngBounds();
		var directionsDisplayOptions = {
			suppressMarkers: true
		};
		var directionsService = new google.maps.DirectionsService;
		var directionsDisplay = new google.maps.DirectionsRenderer;
		directionsDisplay.setOptions( directionsDisplayOptions );

		var offsetHeight = $('nav.navbar').height() * 2;

		var map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {

			var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			var infoButtonString = "";
			var infoImageUrl = "";
			var markerInfowindow = false;
			var icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					fillColor: '#7b7480',
					// anchor: new google.maps.Point(-200, -200),
					// scaledSize: new google.maps.Size(96, 96),
					// strokeWeight: 0,
					scale: 0.5,
					// rotation: 0
				};
			}

			if (attr.info_text || attr.info_title) {
				var contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			var marker = new google.maps.Marker({
				position: locLatLng,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});

			markers.push(marker);

			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);

			if (attr.routes) {
				if (Object.keys(attr.routes).length > 1) {

					if ($('#collapse-location-routes.collapse').length > 0 && $(window).height() > 767) {
						$('#collapse-location-routes.collapse').collapse();
					}

					$('#location-routes .list-group-item-action').on('click', function (e) {
						e.preventDefault();
						$('#location-place-categories').find('.list-group-item-action.active').removeClass('active');
						var elId = $(this).attr('id');
						$.each(attr.routes, function (k, routeAttr) {
							if (elId === routeAttr.title.toLowerCase()) {
								clearMarkers();
								var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);
								calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
							}
						});
					});
				}
			}
		});

		if (settings.places_categories) {

			var placeMarkers = [];

			$('#location-place-categories .list-group-item-action').on('click', function (e) {
				e.preventDefault();
				$('#location-routes').find('.list-group-item-action.active').removeClass('active');

				if ($(this).find('.place-category-icon')) {
					var markerColor = $(this).find('.place-category-icon').css("background-color");
				}

				// Clear directions if any
				directionsDisplay.setMap(null);
				clearMarkers();

				var elId = $(this).attr('id');

				$.each(settings.places_categories, function (title, placesCategory) {
					if (elId === placesCategory.title) {
						$.each(placesCategory.places, function (title, place) {

							var placeMarkerInfowindow = false;
							var placeIcon = {
								// anchor: new google.maps.Point(0, 0),
								strokeColor: markerColor,
								path: 'M75.85 68.35L42.5 110 9.15 68.35A41.83 41.83 0 0 1 0 42.21C0 18.94 19.06 0 42.5 0S85 18.93 85 42.2c0 9.87-3.42 18.95-9.15 26.14zM42.5 22.65c-10.55 0-19.13 8.52-19.13 19s8.58 19 19.13 19 19.13-8.52 19.13-19-8.58-19-19.13-19zm0 7.6',
								fillColor: markerColor,
								fillOpacity: 1,
								// scaledSize: new google.maps.Size(1, 1),
								scale: 0.5,
								// strokeWeight: 0,
								// rotation: 0
							};

							if (placesCategory.marker_svg_file) {
								placeIcon = {
									url: placesCategory.marker_svg_file,
									// anchor: new google.maps.Point(0, 0),
									strokeColor: markerColor,
									fillColor: markerColor,
									fillOpacity: 1,
									// scaledSize: new google.maps.Size(8, 8),
									scale: 1,
									// strokeWeight: 0,
									// rotation: 0
								};
							}

							if (place.title || place.description) {
								var placeContentString = '<div class="">';

								if (place.title) {
									placeContentString = placeContentString + '<h5 class="">' + place.title + '</h5>';
								}
								if (place.description) {
									placeContentString = placeContentString + '<p class="mb-0">' + place.description + '</p>';
								}
								placeContentString = placeContentString + '</div>';

								placeMarkerInfowindow = new google.maps.InfoWindow({
									content: placeContentString
								});
							}

							var placeLocLatLng = new google.maps.LatLng(place.lat, place.lng);

							var placeMarker = new google.maps.Marker({
								position: placeLocLatLng,
								map: map,
								draggable: false,
								icon: placeIcon ? placeIcon : '',
								zIndex: -20,
								infowindow: placeMarkerInfowindow ? placeMarkerInfowindow : false,
							});

							placeMarkers.push(placeMarker);
							bounds.extend(placeLocLatLng);
							map.fitBounds(bounds);
							map.setCenter(bounds.getCenter());
							map.setZoom(map.getZoom()-1);
							map.panTo(bounds.getCenter());
							if (offsetHeight) {
								map.panBy(0, -offsetHeight);
							}
							// if (Object.keys(settings.locations).length > 1) {
							//     map.fitBounds(bounds);
							// }
							// else if (Object.keys(settings.locations).length === 1) {
							//     map.setZoom(settings.zoom-1);
							// }

							placeMarker.addListener('click', function () {
								hideAllPlacesInfoWindows(map, placeMarkers);
								if (this.infowindow) {
									this.infowindow.open(map, this);
								}
								map.setCenter(this.getPosition());
								map.panTo(this.getPosition());

								if (offsetHeight) {
									map.panBy(0, -offsetHeight);
								}
							});
						});
					}
				});
			});
		}

		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}
		else if (Object.keys(settings.locations).length === 1) {
			map.setZoom(settings.zoom);
		}

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
			directionsService.route({
				origin: start,
				destination: end,
				travelMode: 'DRIVING'
			}, function(response, status) {
				if (status === 'OK') {
					directionsDisplay.setDirections(response);
					directionsDisplay.setMap(map);
					// if (offsetHeight) {
					//     map.panBy(500, +offsetHeight);
					// }
					map.setCenter(this.locLatLng);
				} else {
					window.alert('Directions request failed due to ' + status);
				}
			});
		}

		function hideAllPlacesInfoWindows(map, placeMarkers) {
			placeMarkers.forEach(function (placeMarker) {
				if (placeMarker.infowindow) {
					placeMarker.infowindow.close(map, placeMarker);
				}
			});
		}

		// Removes the markers from the map, but keeps them in the array.
		function clearMarkers() {
			setMapOnAll(null);
		}

		// Sets the map on all markers in the array.
		function setMapOnAll(map) {
			for (var i = 0; i < placeMarkers.length; i++) {
				placeMarkers[i].setMap(map);
			}
		}
	};

})(jQuery);
